// extracted by mini-css-extract-plugin
export default {"component--reset":"index-module__component--reset--fmXxO"};